module.exports = __webpack_public_path__ + "static/img/government_bg2.057c44c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/government_bg2.png
// module id = yfPh
// module chunks = 44